export default __webpack_public_path__ + "static/media/Talent_Hothead.ac4c6e2f.png";